import { render, staticRenderFns } from "./shopStore.vue?vue&type=template&id=54b40092&"
import script from "./shopStore.vue?vue&type=script&lang=js&"
export * from "./shopStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports